let offset = 0;
let limit = 1000;
let isCleared = false;

document.addEventListener('DOMContentLoaded', (event) => {
    fetchData();
    document.getElementById('load-more').addEventListener('click', () => {
        offset += limit;
        fetchData();
    });
});

//выбор сколько выводить
function onValueChange() {
            const selectedValue = document.getElementById('DisplayNumberCoins').value;
            limit = selectedValue;
			window.stop();

			fetchData();         
        }

async function fetchData() {
    try {
        const response = await axios.get('https://meme-hub.pro:8080/latest-images');                   //(`https://meme-hub.pro:8080/data?limit=${limit}&offset=${offset}`);
        const data = response.data;
        displayData(data);
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

function displayData(data) {
    isCleared = false;
    const container = document.getElementById('data-container');
    container.innerHTML = ''; // Очищаем контейнер перед добавлением новых элементов
    console.log(data);

    let index = 0;

    function loadNext() {
        if (index >= data.length || isCleared) return;

        const item = data[index];
        const newUrl = `https://meme-hub.pro:8080/coinsImagesBase/${item.imagePath}`;

        const div = document.createElement('div');
        div.className = 'image-container';
		
		

        const img = document.createElement('img');
        img.src = newUrl;
        img.alt = item.imagePath;
        img.height = 30;

        // Добавляем data-атрибуты для mint (можно использовать позже)
        img.setAttribute('data-mint', item.mint);
		img.setAttribute('data-creator', item.creator);

        // Обработчик клика показывает данные item (imagePath + mint)
        div.onclick = () => showModal(item);

        div.appendChild(img);
        container.appendChild(div);

        img.onload = () => {
            if (isCleared) {
                img.remove();
                div.remove();
            } else {
                img.classList.add('dbImageloaded');
            }
        };

        img.onerror = () => {
            console.warn(`Image not found: ${newUrl}`);
            img.remove();
            div.remove();
        };
		
		div.addEventListener('mouseenter', () => {
			highlightByCreator(item.creator, true, img); // <-- передаём текущий img как исключение
		});

		div.addEventListener('mouseleave', () => {
			highlightByCreator(item.creator, false, img);
		});
		
        index++;
        setTimeout(loadNext, 10); // Пауза между загрузками
    }

    loadNext();
}

function highlightByCreator(creator, highlight, excludeElement = null) {
	const checkbox = document.getElementById('showSameDewsCheckbox');
    if (!checkbox.checked) return; // ❌ Не подсвечивать, если чекбокс выключен
    const allImages = document.querySelectorAll('img[data-creator]');
    allImages.forEach(img => {
        if (
            img.getAttribute('data-creator') === creator &&
            img !== excludeElement
        ) {
            if (highlight) {
                img.classList.add('highlight-creator');
            } else {
                img.classList.remove('highlight-creator');
            }
        }
    });
}

function showModal(jsonData) {
    const modal = document.getElementById('myModal');
    const modalBody = document.getElementById('modal-body');
    
    if (modalBody) {
        // Используем данные из jsonData
        modalBody.innerHTML = `<p>ID: ${jsonData.id}</p><p>Upload Date: ${jsonData.upload_date}</p><p>Creator: ${jsonData.creator}</p><p>hash: ${jsonData.hash}</p><p>repeat_count: </p><p>CA: ${jsonData.mint}</p>`;
        modal.style.display = "block";
        
        // Подсвечиваем элементы с одинаковым hash
        highlightElementsByHash(jsonData.hash, true);
    } else {
        console.error('Modal body element not found.');
    }
}

const modal = document.getElementById('myModal');
const span = document.getElementsByClassName('close')[0];

span.onclick = function() {
    modal.style.display = "none";
	
	  // Убираем подсветку при закрытии модального окна
    const modalBody = document.getElementById('modal-body');
    const hash = modalBody.querySelector('p:nth-child(4)').textContent.split(': ')[1];
    highlightElementsByHash(hash, false); // false - для снятия подсветки
}

window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
		
		   // Убираем подсветку при закрытии модального окна
        const modalBody = document.getElementById('modal-body');
        const hash = modalBody.querySelector('p:nth-child(4)').textContent.split(': ')[1];
        highlightElementsByHash(hash, false); // false - для снятия подсветки
    }
}

// Функция для подсветки элементов с одинаковым hash
function highlightElementsByHash(hash, highlight) {
    const allImages = document.querySelectorAll('img[hash]'); // Все изображения с атрибутом hash
    allImages.forEach(img => {
        if (img.getAttribute('hash') === hash) {
            if (highlight) {
                img.classList.add('highlightDB1'); // Добавляем класс для подсветки
            } else {
                img.classList.remove('highlightDB1'); // Убираем класс для подсветки
            }
        }
    });
}

document.getElementById('data-container').addEventListener('click', function(event) {
    const target = event.target.parentElement;   
   console.log('Клик на перемещаемом элементе:', target);
    const x = event.clientX;
    const y = event.clientY;
    const content = target.innerHTML;
    
    if (target.classList.contains('rowsGenData1') || target.classList.contains('balanceZero')) {
        createDraggableElement(content, x, y, target);
    }
});